// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tz3j","title":"styles_title__3Rd6z"};